
import { DisenioPaginas } from "../../layout";
import { useLotesQuery } from "../../../hooks";
import { BuscadorSoloValor, CargandoMedio, TablaListadoLotes } from "../../components";





export const ListadoLotes = () => {


    const { lotesListQuery, page, termino, chagePage, chageTermino } = useLotesQuery();

    return (

        <DisenioPaginas titulo="Listado de Lotes" url="add/lote">
            {(lotesListQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Lotes..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} 
                    titulo='Buscar lote...' place='Buscar x factura, lote...'
                />
                <TablaListadoLotes data={lotesListQuery.data || []} chagePage={chagePage} page={page} />
                </>
            }

        </DisenioPaginas>

    )
}
